import { ThemeConfig } from 'antd';
import defaultTheme from './theme';

function createCustomTheme(theme: ThemeConfig): ThemeConfig {
  return {
    ...theme,

    token: {
      ...defaultTheme.token,
      ...theme.token
    },

    components: {
      ...defaultTheme.components,
      ...theme.components
    }
  };
}

export default createCustomTheme;
